import { getTempFileUrl } from '@/api/modules/base'
import { Message, MessageBox } from 'element-ui'

class FilePreviewUtil {
    // 预览文件（通过文件ID）
    async previewByFileId(uploadFileId) {
        if (!uploadFileId) {
            Message.warning('文件ID不存在，无法预览');
            return;
        }
        try {
            const res = await getTempFileUrl(uploadFileId);
            if (res.code === 200 && res.data) {
                const fileUrl = res.data;
                this.previewByUrl(fileUrl);
            } else {
                Message.error('获取文件失败：' + (res.msg || '未知错误'));
            }
        } catch (error) {
            console.error('获取文件失败:', error);
            Message.error('获取文件失败，请重试');
        }
    }
    // 预览文件（通过URL
    previewByUrl(fileUrl) {
        if (!fileUrl) {
            Message.error('文件URL无效');
            return;
        }
        // 获取文件扩展名
        const extension = this.getFileExtension(fileUrl);
        // 根据文件类型处理预览
        if (this.isImageFile(extension)) {
            // 图片文件：在新窗口中打开
            this.openInNewWindow(fileUrl);
        } else if (this.isPdfFile(extension)) {
            // PDF文件：在新窗口中打开
            this.openInNewWindow(fileUrl);
        } else if (this.isOfficeFile(extension)) {
            // Office文件：提示下载或使用在线预览
            this.handleOfficeFile(fileUrl, extension);
        } else if (this.isTextFile(extension)) {
            // 文本文件：在新窗口中打开
            this.openInNewWindow(fileUrl);
        } else {
            // 其他文件：直接下载
            this.downloadFile(fileUrl);
        }
    }
    // 获取文件扩展名
    getFileExtension(url) {
        const fileName = url.split('/').pop().split('?')[0];
        return fileName.split('.').pop().toLowerCase();
    }
    // 判断是否为图片文件
    isImageFile(extension) {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico'];
        return imageExtensions.includes(extension);
    }
    // 判断是否为PDF文件
    isPdfFile(extension) {
        return extension === 'pdf';
    }
    // 判断是否为Office文件
    isOfficeFile(extension) {
        const officeExtensions = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
        return officeExtensions.includes(extension);
    }
    // 判断是否为文本文件
    isTextFile(extension) {
        const textExtensions = ['txt', 'json', 'xml', 'csv', 'log'];
        return textExtensions.includes(extension);
    }
    // 在新窗口中打开文件
    openInNewWindow(url) {
        const newWindow = window.open(url, '_blank');
        if (!newWindow) {
            Message.warning('弹窗被阻止，请允许弹窗后重试');
            // 备用方案：创建下载链接
            this.downloadFile(url);
        }
    }
    // 处理Office文件
    handleOfficeFile(url, extension) {
        MessageBox.confirm(
            `检测到${extension.toUpperCase()}文件，是否下载到本地查看？`,
            '文件预览',
            {
                confirmButtonText: '下载',
                cancelButtonText: '取消',
                type: 'info'
            }
        ).then(() => {
            this.downloadFile(url);
        }).catch(() => {
            // 用户取消
        });
    }
    // 下载文件
    downloadFile(url, fileName = '') {
        try {
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            Message.success('文件下载已开始');
        } catch (error) {
            console.error('下载文件失败:', error);
            Message.error('下载失败，请重试');
        }
    }
    // 批量预览文件
    async previewMultiple(fileIds) {
        if (!Array.isArray(fileIds) || fileIds.length === 0) {
            Message.warning('没有可预览的文件');
            return;
        }

        for (const fileId of fileIds) {
            await this.previewByFileId(fileId);
            // 添加延迟避免同时打开太多窗口
            await new Promise(resolve => setTimeout(resolve, 500));
        }
    }
    //获取文件类型描述
    getFileTypeDescription(extension) {
        if (this.isImageFile(extension)) return '图片文件';
        if (this.isPdfFile(extension)) return 'PDF文档';
        if (this.isOfficeFile(extension)) return 'Office文档';
        if (this.isTextFile(extension)) return '文本文件';
        return '其他文件';
    }
}

// 创建单例实例
const filePreviewUtil = new FilePreviewUtil();

// 导出实例和类
export default filePreviewUtil;
export { FilePreviewUtil };